import dayjs from "dayjs";

type TFunc = (key: string) => any;

// Shared antd-Table column builders for the metric-detail report tables.
// Every page repeated the same numeric sorter and an identical "time" column;
// these collapse that boilerplate.

// Sort a column whose cells are numbers-or-"-" (dash treated as 0).
export const numberSorter = (key: string) => (a: any, b: any) =>
  (a[key] === "-" ? "0" : a[key]) - (b[key] === "-" ? "0" : b[key]);

// The leading "time" column, identical across all metric pages.
export const timeColumn = (t: TFunc) => ({
  title: t("detail.time"),
  dataIndex: "time",
  key: "time",
  sorter: (a: any, b: any) =>
    dayjs(a.time, "DD/MM/YYYY HH:mm").valueOf() -
    dayjs(b.time, "DD/MM/YYYY HH:mm").valueOf(),
});

// A numeric column: title from i18n key, sorted with numberSorter.
export const numericColumn = (
  t: TFunc,
  titleKey: string,
  dataIndex: string
) => ({
  title: t(titleKey),
  dataIndex,
  key: dataIndex,
  sorter: numberSorter(dataIndex),
});

// A plain (unsorted) column — used by the operation status columns.
export const plainColumn = (t: TFunc, titleKey: string, dataIndex: string) => ({
  title: t(titleKey),
  dataIndex,
  key: dataIndex,
});
